export default __webpack_public_path__ + "static/media/zitsa.b8329b00.png";